module.exports = __webpack_public_path__ + "static/media-kit-fab0c23ad5b1032ab4dd510166a310d0.jpg";